import { useRef, useState } from "react";

import { BTOverflow } from "@btnet/core-components";
import { BTPopover } from "@btnet/core-components/BTPopover";

import { BdsFloat, BdsFloatAlign, BdsIconInfoCircle } from "@buildertrend/components";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";

import UserInfoViewDisplay from "./UserInfoViewDisplay";

export interface ISpecificationInfoButtonProps {
    id: string;
    createdBy?: string;
    createdDate?: Date;
    lastUpdatedBy?: string;
    lastUpdatedDate?: Date;
}

// Renders its own BTOverflow.Item (like TaskWatchersButton) since it owns the popover's anchor ref
// and open state — the caller just drops it inside a BTOverflow.
export const SpecificationInfoButton: React.FC<ISpecificationInfoButtonProps> = ({
    id,
    createdBy,
    createdDate,
    lastUpdatedBy,
    lastUpdatedDate,
}) => {
    const infoIconRef = useRef<HTMLElement>(null);
    const [infoPopover, setInfoPopover] = useState(false);

    const onInfoClick = () => {
        setInfoPopover((open) => !open);
    };

    return (
        <BTOverflow.Item id={id} pinned>
            <span ref={infoIconRef} data-testid="specification-info-icon">
                <BTPopover content="Info" placement="top">
                    <BTButton
                        id="specification-info-button"
                        data-testid="specification-info-button"
                        icon={<BdsIconInfoCircle />}
                        onClick={onInfoClick}
                        type="tertiary"
                        aria-label="Info"
                    />
                </BTPopover>
            </span>
            <BdsFloat
                source={infoIconRef}
                open={infoPopover}
                align={BdsFloatAlign.TR}
                ariaLabel="specificationInfoFloat"
                testid="specificationInfoFloat"
                className="specificationInfoFloat"
                role="tooltip"
                setOpen={setInfoPopover}
            >
                <div className="flex flex-row gap-2">
                    <UserInfoViewDisplay
                        addedByUserName={createdBy}
                        addedByUserDate={createdDate}
                        updatedByUserName={lastUpdatedBy}
                        updatedByUserDate={lastUpdatedDate}
                    />
                </div>
            </BdsFloat>
        </BTOverflow.Item>
    );
};
